import "leaflet/dist/leaflet.css";
import { memo } from "react";
import { MapContainer, Marker, TileLayer } from "react-leaflet";
import L from "leaflet";

const MAP_TILE_URL = "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png";

const markerIcon = new L.Icon({
  iconUrl: "/markers/marker-red.png",
  shadowUrl: "/markers/marker-shadow.png",
  iconSize: [21, 34],
  iconAnchor: [10, 34],
  shadowSize: [34, 34],
});

/** A shared location's map: a still picture — the card around it opens Maps. */
export const ChatLocationMap = memo(({ lat, lng }: { lat: number; lng: number }) => (
  <div className="pointer-events-none h-36 w-full" aria-hidden>
    <MapContainer
      center={[lat, lng]}
      zoom={15}
      dragging={false}
      scrollWheelZoom={false}
      doubleClickZoom={false}
      touchZoom={false}
      boxZoom={false}
      keyboard={false}
      zoomControl={false}
      attributionControl={false}
      style={{ height: "100%", width: "100%", zIndex: 0 }}
    >
      <TileLayer url={MAP_TILE_URL} />
      <Marker position={[lat, lng]} icon={markerIcon} interactive={false} />
    </MapContainer>
  </div>
));
ChatLocationMap.displayName = "ChatLocationMap";
